export class Prospectus {
  approved: boolean;
  prospectusNumber: string;
  aocNumber: string;
  approvalDate: Date;
  expirationDate: Date;
}
